export type CropDraftStatus={dirty:boolean;busy:boolean};
export type CropDraftEvent=(owner:object,event:'attach'|'update'|'detach',status?:CropDraftStatus)=>void;
export function cropDraftKey(v:{width:number;height:number;focus_x:number;focus_y:number;format:string;rotation:number;zoom:number;purpose:string}){
 return JSON.stringify([v.width,v.height,v.focus_x,v.focus_y,v.format,v.rotation,v.zoom,v.purpose]);
}

/** A pending intent never writes or leaves by itself, including after save completion. */
export class CropLeaveGuard{
 private owner:object|null=null;
 private state:CropDraftStatus={dirty:false,busy:false};
 private intent:(()=>void)|null=null;
 private listener=()=>{};
 subscribe(listener:()=>void){this.listener=listener;return()=>{this.listener=()=>{}}}
 get pending(){return Boolean(this.intent)}
 get dirty(){return this.state.dirty}
 get busy(){return this.state.busy}
 get needsWarning(){return this.state.dirty||this.state.busy}
 event:CropDraftEvent=(owner,event,status)=>{
  if(event==='attach'){this.owner=owner;this.state=status||{dirty:false,busy:false}}
  else if(this.owner===owner){if(event==='detach'){this.owner=null;this.state={dirty:false,busy:false}}else if(status)this.state=status}
  if(this.pending)this.listener();
 };
 request(action:()=>void){
  if(this.pending)return false;
  if(this.needsWarning){this.intent=action;this.listener();return false}
  action();return true;
 }
 cancel(){this.intent=null;this.listener()}
 discard(){
  if(this.busy||!this.intent)return false;
  const action=this.intent;this.intent=null;this.listener();action();return true;
 }
 reset(){this.owner=null;this.state={dirty:false,busy:false};this.cancel()}
}
